<template>
    <div id="sipgate-wallpaper-generator" :class="generatorClass">

        <transition name="fadeInFromLeft" appear>
            <img class="fixed brand"
                 src="./assets/sipgate-logo.svg"
                 @click.prevent="goToStartPage"
            >
        </transition>

        <transition name="fadeInFromRight" appear>
            <a href="#" class="fixed about modal-link"
               :class="showAboutModal ? 'is-active' : ''"
               @click.prevent="showAboutModal = !showAboutModal"
            >
                About
            </a>
        </transition>

        <transition name="start-page">
            <template v-if="showStartPage">
                <app-startpage
                        :currentPanel="currentPanel"
                        @startGenerator="showStartPage = false"
                ></app-startpage>
            </template>
            <template v-else>
                <app-generator
                        :currentPanel="currentPanel"
                        :mobilePanel="mobilePanel"
                        :numberOfPanels="numberOfPanels"
                        :panelChangeDirection="panelChangeDirection"
                        @backToStartPage="showStartPage = true"
                        @toggleMobilePanel="mobilePanel = !mobilePanel">
                </app-generator>
            </template>
        </transition>

        <transition name="modal">
            <div class="modal" v-show="showAboutModal">
                <div class="modal__close" @click.stop="showAboutModal = false">
                    <div class="bars">
                        <span class="bar bar-left"></span>
                        <span class="bar bar-right"></span>
                    </div>
                </div>
                <div class="modal__back" @click.stop="showAboutModal = false">zurück</div>
                <div v-bar class="modal__content" @click.stop="showAboutModal = false">
                    <div>
                        <div class="modal__content_inner">
                            <h2><span class="text-din">Über</span> sipgate</h2>
                            <p>
                                sipgate ist kein typischer Telefonieanbieter. Mit knapp 150 Kollegen arbeiten wir
                                gemeinsam an außergewöhnlicher Software, mit der wir den Status quo von privater und
                                Business-Kommunikation täglich hinterfragen und neu denken.
                            </p>

                            <p>
                                Unser Design ist Ausdruck unserer Mission. Es vereinheitlicht unser Produktportfolio –
                                und schafft gleichzeitig Raum für Innovation und Weiterentwicklung. Fest steht: “What
                                you see is what you get”. Wir sind sipgate.
                            </p>

                            <p>
                                Mehr auf <a href="http://sipgatedesign.com">sipgatedesign.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="modal">
            <div class="modal" v-show="showImprintModal">
                <div class="modal__close" @click.stop="showImprintModal = false">
                    <div class="bars">
                        <span class="bar bar-left"></span>
                        <span class="bar bar-right"></span>
                    </div>
                </div>
                <div class="modal__back" @click.stop="showImprintModal = false">zurück</div>
                <div v-bar class="modal__content" @click.stop="showImprintModal = false">
                    <div>
                        <div class="modal__content_inner">
                            <h2>Impressum</h2>
                            <p>
                                sipgate GmbH<br>
                                (V.i.S. des §5 TMG/ §55 RfStV)<br>
                                Gladbacher Straße 74<br>
                                D-40219 Düsseldorf
                            </p>

                            <p>Geschäftsführer: Thilo Salmon, Tim Mois</p>

                            <p>HRB 39841 (eingetragen im Handelsregister des Amtsgerichts Düsseldorf)</p>

                            <p>Die Internetplattform zur Online-Streitbeilegung von Streitigkeiten (sog. „OS-PLattform“)
                                wird
                                nach deren Inbetriebnahme unter dem folgenden
                                Link erreichbar sein:
                            </p>

                            <p><a href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a></p>

                            <p>Steuernummer: 106/5724/7147<br>
                                USt-ID: DE 219349391
                            </p>

                            <p>Aufsichtsbehörde:<br>
                                Bundesnetzagentur für Elektrizität, Gas,<br>
                                Telekommunikation, Post und Eisenbahnen<br>
                                Tulpenfeld 4<br>
                                53113 Bonn
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="modal">
            <div class="modal" v-show="showPrivacyModal">
                <div class="modal__close" @click.stop="showPrivacyModal = false">
                    <div class="bars">
                        <span class="bar bar-left"></span>
                        <span class="bar bar-right"></span>
                    </div>
                </div>
                <div class="modal__back" @click.stop="showPrivacyModal = false">zurück</div>
                <div v-bar class="modal__content" @click.stop="showPrivacyModal = false">
                    <div>
                        <div class="modal__content_inner">
                            <h2>Datenschutz</h2>
                            <p>
                                Datenschutzerklärung sipgate GmbH<br>
                                Datenschutzerklärung
                            </p>

                            <p>Name und Anschrift der für die Datenverarbeitung verantwortlichen Stelle:</p>

                            <p>sipgate GmbH (im Folgenden: “sipgate”)<br>
                                Vertreten durch die Geschäftsführer Herrn Tim Mois und Herrn Thilo Salmon<br>
                                Gladbacher Str. 74
                            </p>

                            <p>40219 Düsseldorf<br>
                                Tel.: 0211-63 55 55-0<br>
                                <a href="mailto:info@sipgate.de">info@sipgate.de</a>
                            </p>

                            <p><a href="http://www.sipgate.de">www.sipgate.de</a></p>

                            <p>Name und Anschrift des Datenschutzbeauftragten der sipgate GmbH:</p>

                            <p>Herr Daniel Marohn<br>
                                sipgate GmbH<br>
                                Gladbacher Str. 74<br>
                                40219 Düsseldorf<br>
                                Tel.: 0211-63 55 55-0<br>
                                <a href="mailto:datenschutz@sipgate.de">datenschutz@sipgate.de</a><br>
                                <a href="http://www.sipgate.de">www.sipgate.de</a>
                            </p>

                            <p>Allgemeines zur Datenverarbeitung</p>

                            <p>A. Umfang der Verarbeitung personenbezogener Daten
                                sipgate verarbeitet personenbezogene Daten grundsätzlich nur, soweit dies zur
                                Bereitstellung
                                einer funktionsfähigen Website sowie der Inhalte und Leistungen der sipgate erforderlich
                                ist.
                                Die Verarbeitung personenbezogener Daten der Nutzer erfolgt regelmäßig nur soweit dies
                                zur
                                Erfüllung vertraglicher oder gesetzlicher Pflichten erforderlich ist oder nach
                                Einwilligung
                                des
                                Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung einer
                                Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten
                                durch
                                gesetzliche Vorschriften gestattet ist.<br>
                                Rechtsgrundlage für die Verarbeitung personenbezogener Daten
                                Soweit sipgate für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
                                betroffenen Person einholt, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (im
                                Folgenden: “DSGVO”) als Rechtsgrundlage.<br>
                                Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages,
                                dessen
                                Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b
                                DSGVO
                                als
                                Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung
                                vorvertraglicher
                                Maßnahmen erforderlich sind.<br>
                                Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
                                Verpflichtung
                                erforderlich ist, der sipgate unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als
                                Rechtsgrundlage.
                            </p>

                            <p>Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen
                                natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich machen, dient
                                Art.
                                6
                                Abs. 1 lit. d DSGVO als Rechtsgrundlage.<br>
                                Ist die Verarbeitung zur Wahrung eines berechtigten Interesses der sipgate oder eines
                                Dritten
                                erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des
                                Betroffenen
                                das
                                erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage
                                für
                                die
                                Verarbeitung.
                            </p>

                            <p>C. Datenlöschung/Speicherdauer<br>
                                Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald
                                der
                                Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies
                                durch
                                den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen
                                oder
                                sonstigen Vorschriften, denen sipgate unterliegt, vorgesehen wurde. Eine Sperrung oder
                                Löschung
                                der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene
                                Speicherfrist
                                abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für
                                einen
                                Vertragsabschluss oder eine Vertragserfüllung besteht.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="footer" appear>
            <template v-if="showStartPage">
                <div class="footer">
                    <ul>
                        <li class="footer__item is-copyright">
                            &copy; sipgate
                        </li>
                        <li class="footer__item">
                            <a class="footer__link" href="#" @click.prevent="showPrivacyModal = !showPrivacyModal">
                                Datenschutz
                            </a>
                        </li>
                        <li class="footer__item">
                            <a class="footer__link" href="#" @click.prevent="showImprintModal = !showImprintModal">
                                Impressum
                            </a>
                        </li>
                    </ul>
                </div>
            </template>
        </transition>

        <app-mobile-nav
                :currentPanel="currentPanel"
                :mobilePanel="mobilePanel"
                :showStartPage="showStartPage"
                @toggleMobilePanel="mobilePanel = !mobilePanel">
            >
        </app-mobile-nav>

        <transition name="fadeInFromRight" appear>
            <a v-if="currentPanel == 3" href="https://www.sipgatedesign.com/" target="_blank"
               class="fixed design-link button button--primary button--arrow button--arrow-centered">
                zu sipgatedesign.com
            </a>
        </transition>
    </div>
</template>

<script>
    import StartPage from './components/StartPage';
    import Generator from './components/Generator';
    import MobileNavigation from './components/MobileNavigation';
    import Devices from './data/devices';

    export default {
        components: {
            appGenerator: Generator,
            appStartpage: StartPage,
            appMobileNav: MobileNavigation,
        },
        data() {
            return {
                currentPanel: 0,
                mobilePanel: true,
                numberOfPanels: 4,
                panelChangeDirection: 'next',
                showAboutModal: false,
                showImprintModal: false,
                showPrivacyModal: false,
                showStartPage: true
            }
        },
        computed: {
            generatorClass() {
                if (this.showStartPage) {
                    return 'is-on-start-page';
                } else {
                    if (this.currentPanel < 3) {
                        return 'is-on-generator';
                    } else {
                        return 'is-on-final';
                    }
                }
            }
        },
        methods: {
            goToStartPage() {
                this.currentPanel = 0;
                this.showStartPage = true;
                this.showAboutModal = false;
                this.showImprintModal = false;
                this.showPrivacyModal = false;
            },
            panelChange(data) {
                if (!this.showStartPage) {
                    if (typeof data === 'string') {
                        if (data === 'prev' && this.currentPanel > 0) {
                            this.mobilePanel = true;
                            this.panelChangeDirection = 'prev';
                            this.currentPanel--;
                        } else if (data === 'next' && (this.currentPanel + 1) < this.numberOfPanels) {
                            this.panelChangeDirection = 'next';
                            this.currentPanel++;
                        }
                    } else if (typeof data === 'number') {
                        if (data >= 0 && data <= this.numberOfPanels) {
                            if (data < this.currentPanel) {
                                this.panelChangeDirection = 'prev';
                            } else {
                                this.panelChangeDirection = 'next';
                            }
                            this.currentPanel = data;
                        }
                    }

                    if (this.currentPanel < 3) {
                        this.mobilePanel = true;
                    } else {
                        this.mobilePanel = false;
                        this.eventHub.$emit('showFinalScreen');
                    }
                }
            },
            preloadAssets() {

                let $basePath = 'dist/';
                let images = new Array();

                // Devices
                for (let group in Devices) {
                    let itemArray = (Devices[group]);
                    for (let k = 0; k < itemArray.length; k++) {
                        let device = itemArray[k];
                        images.push($basePath + device.iconName);
                        if (typeof(device.imageName) != 'undefined') {
                            images.push($basePath + device.imageName);
                        }
                    }
                }

                // Patterns
                let patterns = ['basic', 'io', 'simquadrat', 'sipgate', 'team', 'trunking'];
                for (var i = 0; i < patterns.length; i++) {
                    images.push($basePath + patterns[i] + '.svg');
                    images.push($basePath + patterns[i] + '_bw.svg');
                    images.push($basePath + patterns[i] + '_name.svg');

                    // Backgrounds
                    if (patterns[i] != 'sipgate') {
                        images.push($basePath + patterns[i] + '-bottom.svg');
                        images.push($basePath + patterns[i] + '-bottom-bw.svg');
                        images.push($basePath + patterns[i] + '-top.svg');
                        images.push($basePath + patterns[i] + '-top-bw.svg');
                    }
                }

                // Kudos
                for (i = 1; i < 88; i++) {
                    images.push($basePath + 'kudos_' + i + '.svg');
                }
                let imagesDOM = new Array();
                for (i = 0; i < images.length; i++) {
                    imagesDOM[i] = new Image()
                    imagesDOM[i].src = images[i];
                }
            }
        },
        created() {
            this.eventHub.$on('panelChange', data => {
                this.panelChange(data);
            });

            document.onkeydown = e => {
                e = e || window.event;

                // Exclude input field
                if (typeof(e.path[0] != 'undefined')) {
                    if (e.path[0].localName != 'input') {

                        var handled = false;
                        if (e.key !== undefined) {
                            if (e.key == "ArrowRight") {
                                if (this.showStartPage) {
                                    this.showStartPage = false;
                                }
                                else {
                                    this.panelChange('next');
                                }
                            }

                            if (e.key == "ArrowLeft") {
                                if (!this.showStartPage) {
                                    this.panelChange('prev');
                                }
                            }
                        }

                        if (handled) {
                            event.preventDefault();
                        }
                    }
                }
            };
            this.preloadAssets();
        }
    }
</script>

<style lang="scss">
    @import './assets/scss/dimensions.scss';
    @import './assets/scss/vue/vue-bar';
    @import './assets/scss/elements.scss';
    @import './assets/scss/base.scss';
    @import './assets/scss/modal.scss';
    @import './assets/scss/animations/fade.scss';
    @import './assets/scss/animations/modal.scss';
    @import './assets/scss/animations/sliding.scss';

    .fixed {
        position: fixed;
        transition: opacity .25s linear, visibility 0s linear .5s;
        z-index: 90;
    }

    .about {
        font-family: 'PxGroteskRegular';
        font-size: 14px;
        padding: 8px 14px;
        position: fixed;
        top: $brand-size-x - 4;
        right: $brand-size-x;

        @media(min-width: 786px) {
            top: $brand-size-x * 1.5;
        }

        &:hover {
            color: #DDDDDD;
        }
    }

    .brand {
        cursor: pointer;
        height: $brand-size-x;
        left: $brand-size-x;
        top: $brand-size-x;
        width: auto;
        z-index: 120;

        @media(min-width: 786px) {
            height: $brand-size-x * 1.5;
            left: $brand-size-x * 1.5;
            top: $brand-size-x * 1.5;
        }
    }

    .design-link {
        display: none;

        @media(min-width: 768px) {
            bottom: $brand-size-x;
            border: 1px solid rgba(255, 255, 255, 0.2);
            display: inline-block;
            right: $brand-size-x + 14;
            text-decoration: none;
            text-transform: none;
            transition: border .2s linear;

            &:hover {
                border: 1px solid rgba(255, 255, 255, 1);
            }

            &:after {
                left: auto;
                right: 10px;
            }
        }

    }

    .footer {
        bottom: $brand-size-x / 2;
        font-family: 'PxGroteskRegular';
        font-size: 14px;
        left: $brand-size-x;
        position: fixed;

        @media(min-width: 660px) {
            bottom: $brand-size-x;
            left: $brand-size-x;
        }

        @media(min-width: 786px) {
            left: $brand-size-x * 1.5;
        }

        &__item {
            display: inline-block;
            margin-right: 24px;

            &.is-copyright {
                display: none;

                @media(min-width: 375px) {
                    display: inline-block;
                }
            }
        }

        &__link {
            &:hover {
                color: #DDDDDD;
            }
        }
    }

    .modal-enter-active {
        animation: fadeInModal .5s ease-in-out forwards;

        .modal__back,
        .modal__close {
            animation: slideToLeftIn .5s ease-in-out forwards;
        }

        .modal__content_inner {
            animation: slideToRightIn .25s ease-in-out forwards;
        }
    }

    .modal-leave-active {
        animation: fadeOutModal .5s ease-in-out forwards;

        .modal__back,
        .modal__close {
            animation: slideToRightOut .5s ease-in-out forwards;
        }

        .modal__content_inner {
            animation: slideToLeftOut .25s ease-in-out forwards;
        }
    }

    .start-page-enter-active {
        animation: slideToLeftIn .5s ease-in-out forwards;
    }

    .start-page-leave-active {
        animation: slideToLeftOut .5s ease-in-out forwards;
    }

    .footer-enter-active {
        animation: slideToRightIn .5s ease-out forwards;
    }

    .footer-leave-active {
        animation: slideToLeftOut .25s ease-out forwards;
    }

    .is-on-generator {
        @media (max-width: 1023px) {
            .about, .brand {
                opacity: 0;
                visibility: hidden;
            }
        }
    }

    .is-touch {
        #device-interaction-area {
            &.pinch-tool-tip {
                background: transparent url('./assets/pinch.svg') center center no-repeat;
                background-size: 62px;
            }
        }
    }

    .vue-slider-component .vue-slider-dot {
        background: #000;
        border-radius: 20px;
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue